import { render } from "./terminal.vue?vue&type=template&id=b5ae217a&scoped=true"
import script from "./terminal.vue?vue&type=script&lang=js"
export * from "./terminal.vue?vue&type=script&lang=js"

import "./terminal.vue?vue&type=style&index=0&id=b5ae217a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ae217a"]])

export default __exports__